import { faArrowsUpDown, faCopy, faFilter, faPlusCircle, faScissors, faTrash, faFileCirclePlus, faFolderPlus, faSort, faPaste, faList } from '@fortawesome/free-solid-svg-icons';
import './FilesToolbar.css';
import FilesToolbarButton from '../FilesToolbarButton/FilesToolbarButton'
import { Button, ButtonGroup, Dropdown, DropdownToggle } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FilesToolbar = ({onAddFile, onAddFolder, onCut, onCopy, onPaste, onSort, onFilter, onDelete, cutCopyEnabled, pasteEnabled, switchView, canWrite }) => {
    const handleAddFileButton = () => {
      onAddFile();
    }

    const handleAddFolerButton = () => {
      onAddFolder();
    }

    const handleCutButton = () => {
      onCut()
    }

    const handleCopyButton = () => {
        onCopy()
    }

    const handlePasteButton = () => {
        onPaste()
    }

    const handleSortButton = (order) => {
        onSort(order)
    }

    const handleFilterButton = () => {
        
    }

    const handleDeleteButton = () => {
        onDelete()
    }

  return (
    <div className="files-toolbar">
    <FilesToolbarButton icon={faFileCirclePlus} onClick={handleAddFileButton} disabled={!canWrite} />
    <FilesToolbarButton icon={faFolderPlus} onClick={handleAddFolerButton} disabled={!canWrite} />
    <FilesToolbarButton icon={faScissors} onClick={handleCutButton} disabled={!cutCopyEnabled || !canWrite} />
    <FilesToolbarButton icon={faCopy} onClick={handleCopyButton} disabled={!cutCopyEnabled || !canWrite} />
    <FilesToolbarButton icon={faPaste} onClick={handlePasteButton} disabled={!pasteEnabled || !canWrite}  />
    {/* <FilesToolbarButton icon={faSort} onClick={handleOrderButton} /> */}
    <Dropdown>
      <Dropdown.Toggle variant='outline-accent2' className='files-toolbar-button' size='lg'>
        {/* <FontAwesomeIcon className='files-toolbar-icon' icon={faSort} /> */}
        <span className='files-toolbar-icon'>&#8693;</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => handleSortButton('default')}>Por defecto</Dropdown.Item>
        <Dropdown.Item onClick={() => handleSortButton('modified-desc')}>Más nuevos primero</Dropdown.Item>
        <Dropdown.Item onClick={() => handleSortButton('modified-asc')}>Más antiguos primero</Dropdown.Item>
        <Dropdown.Item onClick={() => handleSortButton('name-asc')}>Por nombre A-Z</Dropdown.Item>
        <Dropdown.Item onClick={() => handleSortButton('name-desc')}>Por nombre Z-A</Dropdown.Item>
        <Dropdown.Item onClick={() => handleSortButton('size-asc')}>Por tamaño ascendente</Dropdown.Item>
        <Dropdown.Item onClick={() => handleSortButton('size-desc')}>Por tamaño descendente</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
    <Dropdown>
      <Dropdown.Toggle variant='outline-accent2' className='files-toolbar-button' size='lg'>
        <FontAwesomeIcon className='files-toolbar-icon' icon={faList} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => switchView('list')}>Lista</Dropdown.Item>
        <Dropdown.Item onClick={() => switchView('grid')}>Iconos</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
    {/* <FilesToolbarButton icon={faFilter} onClick={handleFilterButton} /> */}
    <FilesToolbarButton icon={faTrash} onClick={handleDeleteButton} disabled={!cutCopyEnabled || !canWrite} />
  </div>
  )
};

export default FilesToolbar;